import { PropTypes } from "@l2r-front/l2r-proptypes"

import { useIsMobileDevice } from "../../hooks/useIsMobileDevice"

import * as Styled from "./Sidebar.styled"

export function Sidebar(props) {

    const {
        className,
        children,
        shadowed,
    } = props

    const isMobile = useIsMobileDevice()

    return (
        <Styled.Drawer className={className} isMobile={isMobile} variant="permanent" shadowed={shadowed}>
            {children}
        </Styled.Drawer>
    )
}

Sidebar.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    shadowed: PropTypes.bool,
}

Sidebar.defaultProps = {
    shadowed: false,
}